export default __webpack_public_path__ + "static/media/moscow.6e93731b.png";